import { connectHits } from 'react-instantsearch-dom'
import React from 'react'
import { useSelector } from '~/store/hooks'

import HitsSection from '~/components/features/labo/hitsSection'
import OrderHits from '~/utils/orderHits'
import { contentModel } from '~/utils/contentModel'

const Hits = ({ hits }) => {
  const mainTag = useSelector((state) => state.currentMainTag)
  const profile = useSelector((state) => state.currentprofile)
  const emptyOther = useSelector((state) => state.laboEmptyOther)

  let events = hits.filter((hit) => hit.contentType === 'event')
  let news = hits.filter((hit) => hit.contentType === 'news')
  let pages = hits.filter((hit) => hit.contentType === 'page')
  let docs = hits.filter((hit) => hit.contentType === 'doc')
  let projects = hits.filter((hit) => hit.contentType === 'project')
  let actions = hits.filter((hit) => hit.contentType === 'action')
  let maps = hits.filter((hit) => hit.contentType === 'map')
  let emptyResults = false

  if (
    events.length === 0 &&
    news.length === 0 &&
    pages.length === 0 &&
    docs.length === 0 &&
    projects.length === 0
  ) {
    events = emptyOther.events
    news = emptyOther.news
    pages = emptyOther.pages
    emptyResults = true
  } else {
    events = OrderHits(events, mainTag, profile)
    news = OrderHits(news, mainTag, profile)
    pages = OrderHits(pages, mainTag, profile)
    docs = OrderHits(docs, mainTag, profile)
    projects = OrderHits(projects, mainTag, profile)
    actions = OrderHits(actions, mainTag, profile)
    maps = OrderHits(maps, mainTag, profile)
  }

  return (
    <>
      {maps.length > 0 && (
          <HitsSection
              contentType={contentModel.map}
              hits={maps}
              emptyResults={emptyResults}
          />
      )}
      {news.length > 0 && (
        <HitsSection
          contentType={contentModel.news}
          hits={news}
          emptyResults={emptyResults}
        />
      )}
      {events.length > 0 && (
        <HitsSection
          contentType={contentModel.event}
          hits={events}
          emptyResults={emptyResults}
        />
      )}
      {pages.length > 0 && (
        <HitsSection
          contentType={contentModel.page}
          hits={pages}
          emptyResults={emptyResults}
        />
      )}
      {docs.length > 0 && (
        <HitsSection
          contentType={contentModel.doc}
          hits={docs}
          emptyResults={emptyResults}
        />
      )}
      {projects.length > 0 && (
        <HitsSection
          contentType={contentModel.project}
          hits={projects}
          emptyResults={emptyResults}
        />
      )}
      {actions.length > 0 && (
        <HitsSection
          contentType={contentModel.action}
          hits={actions}
          emptyResults={emptyResults}
        />
      )}
    </>
  )
}

const CustomHitsOther = connectHits(Hits)

export default CustomHitsOther
